module.exports = __webpack_public_path__ + "assets/img/10.20b50483.jpg";